import { DollarSign, Clock, TrendingUp, ArrowDownToLine, Wallet } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export function EarningsTab({ profile, earnings, setWithdrawDialogOpen }) {
  if (!profile) {
    return (
      <div className="text-center py-16 bg-surface rounded-2xl border border-[#262626]">
        <Wallet className="w-16 h-16 mx-auto mb-4 text-[#333]" />
        <h3 className="text-xl font-heading font-bold mb-2">No Earnings Yet</h3>
        <p className="text-[#A1A1AA]">Complete orders to start earning</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div className="bg-surface border border-[#262626] rounded-xl p-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-lime/10 rounded-xl flex items-center justify-center"><DollarSign className="w-6 h-6 text-lime" /></div>
            <div><p className="text-2xl font-mono font-bold text-lime">${(profile.available_balance || 0).toFixed(2)}</p><p className="text-sm text-[#A1A1AA]">Available Balance</p></div>
          </div>
        </div>
        <div className="bg-surface border border-[#262626] rounded-xl p-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-yellow-500/10 rounded-xl flex items-center justify-center"><Clock className="w-6 h-6 text-yellow-500" /></div>
            <div><p className="text-2xl font-mono font-bold">${(earnings?.pending_earnings || 0).toFixed(2)}</p><p className="text-sm text-[#A1A1AA]">Pending</p></div>
          </div>
        </div>
        <div className="bg-surface border border-[#262626] rounded-xl p-6">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-green-500/10 rounded-xl flex items-center justify-center"><TrendingUp className="w-6 h-6 text-green-500" /></div>
            <div><p className="text-2xl font-mono font-bold">${(earnings?.total_earned || 0).toFixed(2)}</p><p className="text-sm text-[#A1A1AA]">Total Earned</p></div>
          </div>
        </div>
      </div>

      {(profile.available_balance || 0) > 0 && (
        <div className="bg-surface border border-lime/30 rounded-xl p-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
            <div><h3 className="font-heading font-bold mb-1">Ready to Withdraw?</h3><p className="text-sm text-[#A1A1AA]">You have ${(profile.available_balance || 0).toFixed(2)} available for withdrawal</p></div>
            <Button onClick={() => setWithdrawDialogOpen(true)} className="btn-primary" data-testid="withdraw-btn"><ArrowDownToLine className="w-4 h-4 mr-2" />Withdraw Funds</Button>
          </div>
        </div>
      )}

      <div className="bg-surface border border-[#262626] rounded-xl p-6">
        <h3 className="font-heading font-bold mb-2">How Earnings Work</h3>
        <ul className="text-sm text-[#A1A1AA] space-y-2">
          <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-lime rounded-full mt-1.5" />You receive 95% of each order (5% platform fee)</li>
          <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-lime rounded-full mt-1.5" />Funds become available after the buyer confirms delivery</li>
          <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-lime rounded-full mt-1.5" />Request withdrawals anytime (minimum $10)</li>
          <li className="flex items-start gap-2"><span className="w-1.5 h-1.5 bg-lime rounded-full mt-1.5" />{profile.stripe_connect_id ? 'Payouts sent directly to your connected bank account' : <>Set up automatic bank payouts in <a href="/settings?tab=payment" className="text-lime underline">Settings</a></>}</li>
        </ul>
      </div>

      {earnings?.earnings_history && earnings.earnings_history.length > 0 && (
        <div className="bg-surface border border-[#262626] rounded-xl overflow-hidden">
          <div className="p-4 border-b border-[#262626]"><h3 className="font-heading font-bold">Earnings History</h3></div>
          <div className="divide-y divide-[#262626]">
            {earnings.earnings_history.slice(0, 10).map((earning) => (
              <div key={earning.id} className="p-4 flex items-center justify-between">
                <div><p className="font-mono text-sm">#{earning.order_id.slice(0, 8)}</p><p className="text-xs text-[#A1A1AA]">{new Date(earning.created_at).toLocaleDateString()}</p></div>
                <div className="text-right"><p className="font-mono text-lime">+${earning.amount.toFixed(2)}</p><Badge className="bg-green-500/10 text-green-400 border-0 text-xs">{earning.status}</Badge></div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
